// extracted by mini-css-extract-plugin
export default {"container":"OnKMAH","seatDetails":"nr00Zd"};